import PropTypes from 'prop-types';
import StepsContext, {useStepsContext} from '../contexts/StepsContext';
import {useContext} from 'preact/hooks'
import {cloneElement} from 'preact';
import Back from './steps/Back';
import {useEventContext} from "../contexts/EventContext";
import {useCustomerContext} from "../contexts/CustomerContext";
import {Icon} from "./index";

const steps = [];

function Steps({ children, className }) {
    const childrenSteps = children.filter(child => child.type.displayName === 'Step' && steps.push(child.props.title));
    const copyChildren = children.map((child) => {
        if (child.type.displayName === 'Step') {
            const stepIndex = steps.findIndex(step => step === child.props.title);
            return cloneElement(child, {
                index: stepIndex,
                first: stepIndex === 0,
                last: stepIndex === childrenSteps.length - 1,
                active: stepIndex === 0,
                done: false,
                ...child.props,
            })
        }
        return child;
    })
    return (
        <div className={`esc-ii-mb-8${className ? ' ' + className : ''}`}>
            {copyChildren}
        </div>
    );
}

Steps.propTypes = {
    className: PropTypes.string,
};

Steps.displayName = 'Steps';

function ContextualSubmit({ mobileOnly = false, desktopOnly = !mobileOnly }) {
    const { canProceedToNextStep, getActiveStep, goToNextStep } = useStepsContext();
    const { isMember, customer } = useCustomerContext();
    const { event, selectedPeriod, addToCart, isStepValid, initAttendees } = useEventContext();

    const primaryButtonClasses = [
        'esc-ii-w-full',
        'esc-ii-py-5',
        'esc-ii-rounded',
        'esc-ii-bg-primary',
        'esc-ii-font-montserrat',
        'esc-ii-text-xs',
        'lg:esc-ii-text-base',
        'esc-ii-font-semibold',
        'esc-ii-mt-6',
        'disabled:esc-ii-opacity-30',
        'esc-ii-transition-all',
        'esc-ii-ease-in-out',
        'esc-ii-duration-300',
        'hover:esc-ii-bg-blue'
    ].filter(Boolean).join(' ');

    const onClick = () => {
        if (isStepValid(getActiveStep())) {
            initAttendees(customer);
            goToNextStep();
        }
    }

    const onContextualSubmit = async (redirectTo = '/cart', deposit = false) => {
        return await addToCart(redirectTo, deposit);
    }

    const isDisabled = !isStepValid(getActiveStep());

    const ContinueButton = () => {
        return (
            <button
                type="button"
                className={primaryButtonClasses}
                onClick={onClick}
                disabled={isDisabled}
            >
            <span className="esc-ii-text-white esc-ii-uppercase">
                Confirm &amp; Specify Attendee Details
            </span>
            </button>
        );
    };

    const MembershipRegisterButton = () => (
        <button
            type="button"
            className={primaryButtonClasses}
            onClick={onClick}
            disabled={isDisabled}
        >
            <span className="esc-ii-text-white esc-ii-uppercase">
                Register For InvestIn Membership
            </span>
        </button>
    );

    const CheckoutOrAddToCartButton = () => (
        <>
            {!event.deposit_enabled && (
                <>
                    <button
                        type="button"
                        className={primaryButtonClasses}
                        onClick={async () => await onContextualSubmit('/checkout')}
                        disabled={isDisabled}
                    >
                        <span className="esc-ii-text-white esc-ii-uppercase">
                            Checkout Now
                        </span>
                    </button>

                    <button
                        type="button"
                        className="esc-ii-w-full esc-ii-py-5 esc-ii-font-montserrat esc-ii-font-semibold esc-ii-text-xs lg:esc-ii-text-base esc-ii-rounded esc-ii-border-2 esc-ii-border-black esc-ii-mt-3 disabled:esc-ii-opacity-30"
                        onClick={async () => await onContextualSubmit()}
                        disabled={isDisabled}
                    >
                        <span className="esc-ii-uppercase">Add to cart</span>
                    </button>
                </>
            )}

            {event.deposit_enabled && (
                <>
                    <button
                        type="button"
                        className={primaryButtonClasses}
                        onClick={async () => await onContextualSubmit('/checkout')}
                        disabled={isDisabled}
                    >
                        <span className="esc-ii-text-white esc-ii-uppercase">
                            Pay Full amount
                        </span>
                    </button>

                    <button
                        type="button"
                        className="esc-ii-w-full esc-ii-py-5 esc-ii-font-montserrat esc-ii-font-semibold esc-ii-text-xs lg:esc-ii-text-base esc-ii-rounded esc-ii-border-2 esc-ii-border-black esc-ii-mt-3 disabled:esc-ii-opacity-30"
                        onClick={async () => await onContextualSubmit('/checkout', true)}
                        disabled={isDisabled}
                    >
                        <span className="esc-ii-uppercase">Pay a Deposit</span>
                    </button>
                </>
            )}
        </>
    );

    const QuickRegisterButton = () => (
        <button
            type="button"
            className={primaryButtonClasses}
            onClick={onClick}
            disabled={isDisabled}
        >
        <span className="esc-ii-text-white esc-ii-uppercase">
            Quick Register
        </span>
        </button>
    );
    const Component = ({ children }) => (
        <div
            className={`${
                desktopOnly ? 'esc-ii-hidden lg:esc-ii-flex' : 'esc-ii-flex'
            } esc-ii-flex-col esc-ii-space-y-2${
                mobileOnly && ' lg:esc-ii-hidden'
            }`}
        >
            {children}
        </div>
    )

    // if (! getActiveStep().last && ! isEmpty(selectedPeriod) && shouldAddEventToAccount(selectedPeriod.type, isMember())) {
    //     return (
    //         <Component>
    //             <QuickRegisterButton />
    //         </Component>
    //     )
    // }

    // if (! getActiveStep().last && ! isEmpty(selectedPeriod) && selectedPeriod.type === 'LIVE_ONLINE') {
    //     return (
    //         <Component>
    //             <MembershipRegisterButton />
    //         </Component>
    //     )
    // }

    if (canProceedToNextStep()) {
        return (
            <Component>
                <ContinueButton />
            </Component>
        )
    }

    return (
        <Component>
            {event.deposit_enabled && (
                <div>
                    <p className="esc-ii-uppercase esc-ii-font-bold esc-ii-text-sm">Deposit information:</p>
                    <p className="esc-ii-font-montserrat esc-ii-text-[13px]">{ event.deposit_description }</p>
                </div>
            )}
            <CheckoutOrAddToCartButton />
        </Component>
    )
}


function Navigation({
                        className,
                        desktopOnly = false,
                    }) {
    const { steps } = useContext(StepsContext);

    const NavStep = ({ step, children }) => {
        const isLast = steps.length === step;
        return (
            <div className={`esc-ii-flex esc-ii-items-center${isLast ? ' lg:esc-ii-flex-row-reverse' : ''}`}>
                {children}
            </div>
        )
    }

    NavStep.Headline = ({step, title, className}) => {
        const isFirst = step === 1;
        const isLast = steps.length === step;
        const isBetweenFirstAndLast = !isFirst && !isLast;
        const classes = [
            'esc-ii-font-montserrat',
            'esc-ii-no-underline',
            'esc-ii-text-xs',
            'esc-ii-uppercase',
            'esc-ii-ml-3.5',
            'lg:esc-ii-ml-0',
            isFirst && 'lg:esc-ii-pr-4',
            isBetweenFirstAndLast && 'lg:esc-ii-px-4',
            isLast && 'lg:esc-ii-pl-4',
            className,
        ];

        return (
            <h6 className={classes.filter(Boolean).join(' ')}>
                {title}
            </h6>
        )
    };

    const ActiveNavStep = ({ step, title }) => (
        <NavStep step={step}>
            <NavStep.Headline step={step} title={title} className={`esc-ii-font-bold`} />
            <span className="esc-ii-text-xs esc-ii-font-bold esc-ii-flex esc-ii-justify-center esc-ii-items-center esc-ii-w-[26px] esc-ii-h-[26px] lg:esc-ii-w-[30px] lg:esc-ii-h-[30px] esc-ii-border esc-ii-text-center esc-ii-rounded-full esc-ii-bg-primary esc-ii-text-white esc-ii-border-primary">
                {step}
            </span>
        </NavStep>
    );

    const InActiveNavStep = ({ step, title, done }) => (
        <NavStep step={step}>
            <NavStep.Headline step={step} title={title} className={`esc-ii-font-bold`} />
            { done ? (
                <span className={`esc-ii-flex esc-ii-justify-center esc-ii-items-center esc-ii-font-bold esc-ii-w-[26px] esc-ii-h-[26px] esc-ii-border esc-ii-text-center esc-ii-rounded-full esc-ii-bg-blue esc-ii-border-blue`}>
                    <Icon.Tick className="esc-ii-h-3 esc-ii-w-3" stroke={`#fff`} />
                </span>
            ) : (
                <span className="esc-ii-text-xs esc-ii-flex esc-ii-justify-center esc-ii-items-center esc-ii-w-[26px] esc-ii-h-[26px] lg:esc-ii-w-[30px] lg:esc-ii-h-[30px] esc-ii-border esc-ii-text-center esc-ii-rounded-full">
                    {step}
                </span>
            )}
        </NavStep>
    );

    return (
        <header
            className={`${
                desktopOnly ? 'esc-ii-hidden lg:esc-ii-flex' : 'esc-ii-flex'
            } esc-ii-flex-col esc-ii-pt-2.5 esc-ii-space-y-3 lg:esc-ii-mt-5 lg:esc-ii-space-y-0 lg:esc-ii-flex-row lg:esc-ii-items-center${
                className ? ' ' + className : ''
            }`}
        >
            {steps.map((step, index) => (
                step.active ? (
                    <>
                        <ActiveNavStep key={index} step={index+1} title={step.title} />
                        {index >= 0 && ((index+1) !== steps.length) && (<span className="lg:esc-ii-h-px lg:esc-ii-flex-grow lg:esc-ii-bg-charcoal lg:esc-ii-opacity-40"></span>)}
                    </>
                ) : (
                    <>
                        <InActiveNavStep key={index} step={index+1} title={step.title} done={step.done} />
                        {index >= 0 && ((index+1) !== steps.length) && (<span className="lg:esc-ii-h-px lg:esc-ii-flex-grow lg:esc-ii-bg-charcoal lg:esc-ii-opacity-40"></span>)}
                    </>
                )
            ))
            }

        </header>
    );
}

Navigation.propTypes = {
    className: PropTypes.string,
    desktopOnly: PropTypes.bool,
};



Steps.Navigation = Navigation;
Steps.ContextualSubmit = ContextualSubmit;
Steps.Back = Back;

export default Steps;
